import { IQuestion } from '~/src/features/internet/internet-represent';

export const dataQuestionsCountryHouse: IQuestion[] = [
    {
        id: 1,
        question: 'Сколько стоит подключить интернет на даче?',
        answer: `<p>Стоимость подключения — от 1 000 рублей. Если вы хотите провести мощный
            интернет на дачу в области, оставьте заявку – мы рассчитаем точную стоимость.</p>`,
    },
    {
        id: 2,
        question: 'Как провести интернет на дачу? И сколько стоит первый месяц за интернет в своем доме?',
        answer: `<ol>
                <li>Подключение к сети. Мы прокладываем интернет-кабель на вашей даче и устанавливаем специальный PON-терминал для того, чтобы сразу подключить
                    ваши устройства и роутер к интернету.</li>
                <li>Настройка роутера. Мы сами настроим <a href='/internet/equipment' target='_blank'>оборудование</a>, пока вы занимаетесь делами. А ещё подскажем,
                    какой роутер больше подходит для ваших целей.</li>
                <li>Выбор тарифа. Цена интернета напрямую зависит от ваших потребностей. Если вы не знаете, какой тарифный план выбрать, мы подберём подходящий для
                    вас. Следить за расходами вы сможете онлайн в мобильном приложении «Мой Дом.ру».</li>
            </ol>`,
    },
    {
        id: 3,
        question: 'Влияют ли погодные условия на скорость и стабильность интернета за городом?',
        answer: `<p>С технологией GPON интернет в на вашей даче будет стабильным в любую погоду: жара, дождь, снег, гроза или сильный ветер. В отличие от 3G/4G и спутниковых
            тарелок, эта технология обеспечивает устойчивый сигнал независимо от капризов природы, даже если к сети подключено несколько устройств.</p>`,
    },
    {
        id: 4,
        question: 'Будет ли ловить Wi-Fi на участке рядом с домом, в беседке или бане?',
        answer: `<p>Всё зависит от площади вашего дома, размера участка и удалённости бани или беседки. Если участок больше 100 кв.м., лучше
            выбрать <a href='/internet/equipment/wifi-system-tp-link-deco-m4' target='_blank'>Mesh-систему</a>.</p>
            <p>Она состоит из нескольких Wi-Fi модулей и обеспечивает быстрый сигнал, пока вы передвигайтесь по дому или участку. Мы рассчитаем,
                сколько нужно модулей на вашу площадь дома. А инженеры настроят устройство так, чтобы интернет ловил везде.</p>`,
    },
];
